import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.board.list');
import { OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-board-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.board.list/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}`],
})
export class PortalBoardListComponent implements OnInit {
    @Input() boardId: string = '';
    @Output() onSelect = new EventEmitter<string>();
    @Output() onWrite = new EventEmitter<void>();

    public loading: boolean = false;
    public board: any = null;
    public posts: any[] = [];
    public notices: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 20;
    public search: any = { text: '', category_id: '' };
    public categories: any[] = [];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadBoard();
        await this.load();
    }

    public async loadBoard() {
        if (!this.boardId) return;
        const params = new URLSearchParams();
        params.append('board_id', this.boardId);
        try {
            const res = await fetch('/api/board/board-info', { method: 'POST', body: params });
            const result = await res.json();
            if (res.ok) {
                this.board = result.data;
                this.categories = result.data?.categories || [];
            }
        } catch (e) { }
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const params = new URLSearchParams();
        params.append('board_id', this.boardId);
        params.append('text', this.search.text);
        params.append('category_id', this.search.category_id);
        params.append('page', String(this.page));
        params.append('dump', String(this.dump));

        try {
            const res = await fetch('/api/board/posts', { method: 'POST', body: params });
            const result = await res.json();
            if (res.ok) {
                this.posts = result.data?.rows || [];
                this.total = result.data?.total || 0;
                this.notices = result.data?.notices || [];
            }
        } catch (e) { }

        this.loading = false;
        await this.service.render();
    }

    public async searchPosts() {
        this.page = 1;
        await this.load();
    }

    public async filterCategory(catId: string) {
        this.search.category_id = this.search.category_id === catId ? '' : catId;
        this.page = 1;
        await this.load();
    }

    public selectPost(postId: string) {
        this.onSelect.emit(postId);
    }

    public writePost() {
        this.onWrite.emit();
    }

    public async pageMove(page: number) {
        this.page = page;
        await this.load();
    }

    public get totalPages(): number {
        return Math.ceil(this.total / this.dump);
    }
}

export default PortalBoardListComponent;